import React, {Component} from "react";
import {Button, Center, Grid, Group, Header, Image, Text, TextInput} from "@mantine/core";
import {Colors} from "../Constants/Colors";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {useLocation, useNavigate} from "react-router-dom";
import CustomToast from "../components/CustomToast";
import {socket} from "../components/Socket";
import {Defaults} from "../Constants/Constants";
class Login extends Component{
    constructor(props) {
        super(props);
        this.state ={
            loginId: "",
            password: "",
            isVisible: false
        }
    }

    componentDidMount() {
        socket.on('success',this.handleSuccess);
        socket.on('failure',this.handleFailure);
    }
    componentWillUnmount() {
        socket.off('success');
        socket.off('failure');
    }
    handleSuccess = (data) =>{
        console.log(data);
        switch(data?.type){
            case 'userLogin':
                localStorage.setItem('user',data?.user);
                this.setState({alert: {message: 'Logged in Successfully', action: 'success'}});
                this.props.navigation('/');
                break;
        }
    }
    handleFailure = (data) =>{
        console.log(data);
        switch(data?.type){
            case 'userLogin':
                this.setState({alert: {message: data?.message, action: 'error'}});
                break;
        }
    }
    handleChange = (e) => {
        const {name,value} = e.target;
        this.setState({[name]: value});
    }
    showPassword = () =>  this.setState({isVisible:true});
    hidePassword = () =>  this.setState({isVisible:false});
    handleLogin = () =>{
        const {loginId,password} = this.state;
        if(loginId.trim() != '' && password.trim() != ''){
            socket.emit('userLogin',{loginId,password});
        }else{
            if(loginId.trim() === ''){
                this.setState({alert: {message: 'LoginId is Required', action: 'error'}});
            }else{
                this.setState({alert: {message: 'Password is Required', action: 'error'}});
            }
        }
    }
    hideSnackbar = () => this.setState({alert: undefined});

    render() {
        const {email,password,isVisible,alert} = this.state;
        return <div>
             <Header style={{backgroundColor:'#075E54',width: '100%',height: 50}} fixed position={{top: 0,left: 0}} >
                <Grid style={{paddingTop: 10,paddingLeft: 10}}>
                    <Grid.Col span={12}><Text color={'white'}>{Defaults.AppName}</Text></Grid.Col>
                </Grid>
            </Header>
            <Center mt={100}>

                <Grid sx={{marginBottom: 3}}>
                    <Grid.Col span={12}>{alert != undefined && <CustomToast alert={alert} onHide={this.hideSnackbar} />}</Grid.Col>
                    <Grid.Col span={12} sx={{alignItems: 'center'}} >
                        <Image src={require('../images/logo.png')} alt="img"  fit="contain" height={100}/>
                    </Grid.Col>
                    <Grid.Col span={12} lg={6}>
                        <TextInput
                            id="outlined-textarea"
                            label="Login Id"
                            placeholder="Enter Login Id"
                            fullWidth
                            value={email}
                            name={'loginId'}
                            onChange={this.handleChange}
                            size={'md'}
                        />
                    </Grid.Col>
                    <Grid.Col span={12} lg={6}>
                        <TextInput
                            id="outlined-textarea"
                            label="Password"
                            placeholder="Enter Password Here"
                            fullWidth
                            name={'password'}
                            value={password}
                            onChange={this.handleChange}
                            size={'md'}
                            type={isVisible? 'text': 'password'}
                            // sx={{marginBottom: 3,marginTop: 5}}
                            rightSection={isVisible? <VisibilityOff onClick={this.hidePassword} /> : <Visibility  onClick={this.showPassword} />}

                        />
                    </Grid.Col>
                    <Grid.Col span={12} lg={12}>
                        <Group position={'center'} mt={10}>
                            <Button sx={{backgroundColor: Colors.Primary}} onClick={this.handleLogin}>Login</Button>
                        </Group>
                    </Grid.Col>
                </Grid>
            </Center>
        </div>
    }
}
export default function(props){
    const navigation = useNavigate();
    const {state} = useLocation();
    return <Login {...props} params={state} navigation={navigation} />
};
